import React from 'react';
import type { ReleaseSchema } from '../../../types/schema';
import { ComponentProps, deps, inject, observer } from '../../../lib/component';
import { classes, style } from 'typestyle';
import { borderRadius } from '../../../theme/border';
import { ResponsiveImage } from '../atoms/ResponsiveImage';

interface ReleaseArtworkProps extends ComponentProps {
  release: ReleaseSchema;
  small?: boolean;
  className?: string;
}

const styles = {
  wrapper: style({
    position: 'relative',
    width: '100%',
  }),
  imageWrapper: (small: boolean) =>
    style({
      position: 'relative',
      width: '100%',
      paddingBottom: '100%',
      overflow: 'hidden',
      borderRadius: small ? borderRadius.MEDIUM : borderRadius.LARGE,
    }),
  image: style({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }),
};

export const ReleaseArtwork: React.FC<ReleaseArtworkProps> = inject(deps)(
  observer(
    ({
      release,
      small = false,
      className,
      model: {
        image: { cover },
      },
    }) => {
      if (!release || !release.images) return null;

      const { identity } = release.images;
      const imageSizes = [200, 400, 600];

      const imageSources = imageSizes.map((size) => {
        return cover(identity, {
          ignoreDimensions: true,
          width: size,
          height: size,
          crop: true,
        });
      });

      return (
        <div className={classes(styles.wrapper, className)}>
          <div className={styles.imageWrapper(small)}>
            <ResponsiveImage
              className={styles.image}
              alt={`Artwork for ${release.title} by ${release.artist.name}`}
              src={imageSources}
              width={imageSizes}
              height={imageSizes}
            />
          </div>
        </div>
      );
    }
  )
);
